import { FavoriteResourceInterface } from '../../domain/interface/favorite_resource_interface';
import { FavoriteRepository } from '../../domain/repository/favorite_repository';
import { FavoriteApiService } from '../data_source/favorite_api_service';

export class FavoriteRepositoryImpl implements FavoriteRepository {
  private favoriteApiService: FavoriteApiService;

  constructor() {
    this.favoriteApiService = new FavoriteApiService();
  }

  async getFavoritesByUserIdAndThemeId(
    userId: string,
    themeId: string,
  ): Promise<FavoriteResourceInterface[]> {
    const response =
      await this.favoriteApiService.getFavoritesByUserIdAndThemeId(
        userId,
        themeId,
      );
    return response.data;
  }

  async addFavorite(
    userId: string,
    resourceId: string,
  ): Promise<{ _id: string }> {
    const response = await this.favoriteApiService.addFavorite(
      userId,
      resourceId,
    );
    return response.data;
  }

  async removeFavorite(favoriteId: string): Promise<void> {
    await this.favoriteApiService.removeFavorite(favoriteId);
  }
}
